module.exports = __webpack_public_path__ + "img/plat_4968.752efa81.jpg";